import React from "react";
import { NewsDetailData } from "../../../pages/NewsDetail/types";


export const NewsDetailImage: React.FC<{ newsData: NewsDetailData }> = ({
  newsData,
}) => {

  return (
    <div className="rounded-[12px] md:w-[698px] md:h-[250px] md:rounded">
      <img
        src={newsData.image}
        alt={newsData.headline}
        className="w-full h-full object-cover rounded"
      />
    </div>
  );
};

